import {styled, px} from '../../utils';
import BaseButton from './BaseButton';
import {FloatingButtonProps} from './types';

export default styled(BaseButton)<FloatingButtonProps>(({theme}) => ({
  position: 'fixed',
  right: 20,
  bottom: 20,
  borderRadius: '50%',
  width: 65,
  height: 65,
  lineHeight: px(65),
  background: theme.color.primary,
  color: '#fff',
  ':hover': {
    background: theme.color.secondary
  },
  i: {
    fontSize: 24
  }
}));



// WEBPACK FOOTER //
// ./src/components/Button/FloatingButton.tsx